export class Fee {

    orderReference: string;
    type: string;
    description: string;
    numberOfItems: number;
    feeDate: Date;
    fee: number;

    constructor(){}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/fee.ts